import { createSlice } from "@reduxjs/toolkit";
import { getFabricCuttingList } from "../../reduxApi/admin/FabricCuttingReduxApi";
const FabricCuttingSlice = createSlice({
    name: "FabricCutting",
    initialState: {
        status: "idle",
        isFiltered: false,
        FabricCutting: [],
    },

    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },

        deleteFabricCuttingAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.FabricCutting.findIndex(
                    (item) => item.ROWID === id
                );

                if (index !== -1) {
                    state.FabricCutting.splice(index, 1);
                }
            });
        },

        updateFabricCuttingAction: (state, action) => {
            const index = state.FabricCutting.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );

            if (index !== -1) {
                state.FabricCutting[index] = action.payload;
            }
        },

        addFabricCuttingAction: (state, action) => {
            state.FabricCutting.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getFabricCuttingList.pending, (state) => {
                state.status = "pending";
            })

            .addCase(getFabricCuttingList.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.FabricCutting = action.payload?.data || action.payload
            })

            .addCase(getFabricCuttingList.rejected, (state) => {
                state.status = "rejected";
            });
    },
});

export const {
    deleteFabricCuttingAction,
    updateFabricCuttingAction,
    addFabricCuttingAction,
    setFilteredStatus,
    clearFilters,
} = FabricCuttingSlice.actions;

export default FabricCuttingSlice.reducer;